export const actions = {
    GET_USERPREFERENCE: 'GET_USERPREFERENCE',
    GET_HOME_ANNOUNCEMENT: 'GET_HOME_ANNOUNCEMENT'
};